"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBaseLegacyEvent = exports.isBaseObjectActionEvent = void 0;
function isBaseObjectActionEvent(event) {
    if (typeof event !== 'object') {
        return false;
    }
    const { object, action, properties } = event;
    return (typeof object === 'string' &&
        typeof action === 'string' &&
        typeof properties === 'object');
}
exports.isBaseObjectActionEvent = isBaseObjectActionEvent;
function isBaseLegacyEvent(item) {
    if (typeof item !== 'object') {
        return false;
    }
    const { event, eventCategory, eventLabel, eventAction, ecommerce } = item;
    const isMaybe = (value, type) => typeof value === type || typeof value === 'undefined';
    return (typeof event === 'string' &&
        isMaybe(eventCategory, 'string') &&
        isMaybe(eventLabel, 'string') &&
        isMaybe(eventAction, 'string') &&
        isMaybe(ecommerce, 'object'));
}
exports.isBaseLegacyEvent = isBaseLegacyEvent;
//# sourceMappingURL=index.js.map